import { render, staticRenderFns } from "./previewDetail.vue?vue&type=template&id=01825f29&scoped=true"
import script from "./previewDetail.vue?vue&type=script&lang=js"
export * from "./previewDetail.vue?vue&type=script&lang=js"
import style0 from "./previewDetail.vue?vue&type=style&index=0&id=01825f29&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01825f29",
  null
  
)

export default component.exports